import { createAction } from '@reduxjs/toolkit';
import { SeoLimitations } from 'services/api/seoAnalysis/types';
import { UnsplashImagesLimitations } from 'services/api/unsplash/types';

export const updateSeoLimitations = createAction<SeoLimitations>('pricing/updateSeoLimitations');

export const updateUnsplashImagesLimitations = createAction<UnsplashImagesLimitations>(
  'pricing/updateUnsplashImagesLimitations'
);
